import React from "react";
import ViewScroller from "../Components/Common/ViewScroller/ViewScroller";
import RightModal from "../Components/Modals/RightModal/RightModal";
import DepartureViewContent from "../Components/Departure";

const DepartureView = () => {
  return (
    <ViewScroller>
      <div className="w100 d-flex flex-column gap-4 h-100">
        <DepartureViewContent />
        <RightModal width={70} />
      </div>
    </ViewScroller>
  );
};

export default DepartureView;
